import { render, staticRenderFns } from "./IconTableEdit.vue?vue&type=template&id=079d7790"
import script from "./IconTableEdit.vue?vue&type=script&lang=js"
export * from "./IconTableEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports